export const svgToUri = (svg: string): string => {
  const base64Svg = btoa(svg);
  return `data:image/svg+xml;base64,${base64Svg}`;
};
